import { createContext } from "react";

const ExtraActivityContext = createContext();

export default ExtraActivityContext;